<template lang="pug">
modal#no-subscriber-modal(
  :process-button-label='$t("button.ok")'
  :showCancelButton='false'
  :title='$t("modal.noSubscriber.title")'
  @process='closeModal'
  ref='modal'
  size='sm'
)
  p {{ $t('modal.noSubscriber.message') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/mailbox-no-subscriber.svg')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'NoSubscriberModal',
  components: {
    Modal,
  },
  methods: {
    async closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
